<template>
  <div v-if="inputedValue.dialog">
    <DialogBase
      v-model="inputedValue.dialog"
      :title="title"
      :isFooter="isFooter"
      :isFooterColor="isFooterColor"
      :width="width"
      isCardColor="true"
    >
      <template #title="{ dialogTitle }">
        <span class="pl-5 py-2 dialogTitleStyle">
          {{ $t(dialogTitle) }}
        </span>
      </template>

      <v-container fluid class="pa-2 baseStyle">
        <v-row v-for="(rec, index) in tables" :key="index">
          <v-col>
            <ExpansionPanel
              :open="true"
              :isFooter="isExpansionPanelFooter"
              class="border rounded-lg"
            >
              <template #header>
                <span class="font-weight-bold py-4 tableTitleStyle">
                  {{ getRecTitle(rec) }}
                </span>
                <span v-if="rec.subTitle" class="pl-4 tableSubTitleStyle">
                  {{ getRecSubTitle(rec) }}
                </span>
              </template>
              <template #content>
                <slot :name="rec.name" v-bind:item="rec">
                  <StatusHistoryTable
                    :pageType="pageType"
                    :items="rec.items"
                    :itemKey="rec.itemKey"
                  />
                </slot>
              </template>
              <template #footer>
                <slot :name="'expansionPanelFooter' + index" />
              </template>
            </ExpansionPanel>
          </v-col>
        </v-row>
      </v-container>

      <template #footer>
        <slot name="footer" />
      </template>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from '../DialogBase'
import { ExpansionPanel, StatusHistoryTable } from '@/components/items'

export default {
  components: {
    DialogBase,
    ExpansionPanel,
    StatusHistoryTable
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },

    isFooter: { default: false },
    isFooterColor: { default: true },
    isExpansionPanelFooter: { default: false },

    pageType: { default: '' },

    tables: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    displayFlg: false
  }),
  methods: {
    getRecTitle(rec) {
      if (!rec) {
        return ''
      }
      return this.$t(rec.title)
    },
    getRecSubTitle(rec) {
      if (!rec) {
        return ''
      }
      return this.$t(rec.subTitle)
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
.dialogTitleStyle {
  font-size: 22px;
}
.tableTitleStyle {
  padding-left: 30px;
  font-size: 15px;
}
.tableSubTitleStyle {
  font-size: 13px;
}
.border {
  border: 1px solid #d8d8d8 !important;
}
</style>
